import { Component, Input, OnInit } from '@angular/core';
import { FormWizardPageElement } from 'src/app/models/form-wizard-template.model';
import * as _ from 'lodash';

@Component({
  selector: 'app-select-all-element',
  templateUrl: './select-all-element.component.html',
  styleUrls: ['./select-all-element.component.scss']
})
export class SelectAllElementComponent implements OnInit {
  @Input() element: FormWizardPageElement | undefined;
  @Input() formValues: any | undefined;
  public testValue = false;
  constructor() { }

  ngOnInit(): void {
  }

  public getControlName(): string {
    return 'input' + this.getName();
  }

  public getName(): string {
    return this.element?.name.replace(',', '') ?? '';
  }

  public getLabel(): string {
    return this.element?.label ?? '';
  }

  public isLabelVisible(): boolean {
    return this.getLabel() !== '' && this.isControlVisible();
  }

  public isControlVisible(): boolean {
    return !_.isNil(this.element) && !_.isNil(this.formValues);
  }

  public isIndeterminate(): boolean {
    if (this.getValue()) {
      return false;
    }

    let result = false;

    if (!_.isNil(this.element?.name)) {
      this.element?.name.split(',').forEach((name) => {
        if (this.formValues[name]) {
          result = true;
        }
      });
    }

    return result;
  }

  public getValue(): boolean {
    let result = true;

    if (!_.isNil(this.element?.name)) {
      this.element?.name.split(',').forEach((name) => {
        if (!this.formValues[name]) {
          result = false;
        }
      });
    } else {
      result = false;
    }

    return result;
  }

  public setValue(value: boolean): void {
    if (!_.isNil(this.element?.name)) {
      this.element?.name.split(',').forEach((name) => {
        this.formValues[name] = value;
      });
    }
  }
}
